import { createContext, useContext } from 'react';
import { ListType } from 'modules/domains/list';
import { List } from '../types';

type QueryContextState = {
  isLoading: boolean;
  lists: List[];
  totalListCount: number;
  listSizes: Record<List['id'], number | undefined>;
  listCountByType: { [key in ListType | 'All']?: number };
  refetch: () => void;
};

export const defaultState: QueryContextState = {
  isLoading: false,
  lists: [],
  totalListCount: 0,
  listSizes: {},
  listCountByType: {},
  refetch: () => null,
};

export const QueryContext = createContext<QueryContextState>(defaultState);

export const useQueryContext = () => useContext(QueryContext);
